import shoplistPref from './shoplistPref';

const preflist = new shoplistPref();

export default class shoplist {
    constructor() {

        //area&pref
        this.area = document.querySelectorAll('.l-area');
        this.pref = document.querySelectorAll('.l-area-pref');
        this.areaName = document.querySelectorAll('.l-area-name');
        this.prefName = document.querySelectorAll('.l-area-pref-name');
        this.prefList = document.querySelectorAll('.l-area-pref-list');
        this.areasearchSelect = document.getElementById('p-search-area-list');
        this.prefsearchSelect = document.getElementById('p-search-pref-list');
        this.areaNothing = document.querySelector('.l-area__nothing');
        this.optionsArea = this.areasearchSelect.options;
        this.options = this.prefsearchSelect.options;

        //checkBox
        this.checkForm = document.getElementById('p-check-form');
        this.checkboxes = this.checkForm.querySelectorAll('input[type="checkbox"]');
        this.shopDetail = document.querySelectorAll('.shop-detail');

        this.$rootLoad = document.getElementById("l-root-load");

        //選択状態
        this.areaSelectValue = 'area00';
        this.prefSelectValue = 'area00';
        this.areaElement = '';
        this.prefElement = '';
        this.selectIndex = 0;
    }

    init() {

        this.areaElement = this.area;
        this.prefElement = this.prefName;

        for (let i = 0; i < this.area.length; i++) {
            this.area[i].classList.add('is-show');
        }
        for (let i = 0; i < this.shopDetail.length; i++) {
            this.shopDetail[i].classList.add('is-show');
        }

        TweenMax.set(this.areaNothing, {
            display: 'none',
            opacity: 0,
        });

        this.areasearchSelect.addEventListener('change', () => {
            this.areaSelect();
            this.areaReset();
            this.areaSort();
            this.prefUpdate();
            this.prefReset();
            this.prefSort();
            this.update();
            setTimeout(() => {
                this.resize();
            }, 1e2);
        });

        this.prefsearchSelect.addEventListener('change', () => {
            this.prefSelect();
            this.areaReset();
            this.areaSort();
            this.prefReset();
            this.prefSort();
            this.update();
            setTimeout(() => {
                this.resize();
            }, 1e2);
        });

        //checkBox
        this.checkForm.addEventListener('change', () => {

            let _checkedValue = [];
            for (let i = 0; i < this.checkboxes.length; i++) {

                if (this.checkboxes[i].checked) {
                    const _value = this.checkboxes[i].value;
                    // チェックされているチェックボックスのvalueを配列に渡す
                    _checkedValue.push(_value);
                }
            }
            this.check(_checkedValue);
        });

        // 開閉
        for (let i = 0; i < this.areaName.length; i++) {
            let _index = i;
            this.areaName[i].onclick = () => {
                if (this.areaName[_index].classList.contains('is-open')) {
                    this.close(_index);
                } else {
                    this.open(_index);
                }
            };
        }

    }

    // ------------------------------------------------

    //エリア

    // ------------------------------------------------

    areaSelect() {

        this.areaSelectValue = this.areasearchSelect.value;
        if (this.areaSelectValue === 'area00' && this.prefSelectValue !== 'area00') { // 全てか個別化の判定
            this.areaElement = this.area;
        } else {
            this.areaElement = document.querySelectorAll('#p-' + this.areaSelectValue);
        }

        this.prefElement = this.prefName;

        this.update();

    }

    areaReset() {
        //エリアの非表示
        for (let i = 0; i < this.area.length; i++) {
            TweenMax.set(this.area[i], {
                display: 'none',
                opacity: 0,
            });
            this.area[i].classList.remove('is-show');
        }
    }

    areaSort() {
        for (let i = 0; i < this.areaElement.length; i++) {
            TweenMax.set(this.areaElement[i], {
                display: 'block',
                opacity: 1,
            });
            this.areaElement[i].classList.add('is-show');
        }
        for (let i = 0; i < this.areaName.length; i++) {
            this.areaName[i].classList.remove('is-close');
            this.areaName[i].classList.add('is-open');
        }
        TweenMax.set(this.pref, {
            display: 'block',
            opacity: 1,
        });
    }

    // ------------------------------------------------

    //都道府県

    // ------------------------------------------------

    prefSelect() {

        this.areaSelectValue = this.prefsearchSelect.selectedIndex;
        this.areaSelectValue = this.prefsearchSelect.options[this.areaSelectValue];
        this.areaSelectValue = this.areaSelectValue.dataset.val;

        if (this.areaSelectValue === 'area00' && this.prefSelectValue !== 'area00') { // 全てか個別化の判定
            this.areaElement = this.area;
        } else {
            this.areaElement = document.querySelectorAll('#p-' + this.areaSelectValue);
        }

        this.prefSelectValue = this.prefsearchSelect.value;

        if (this.prefSelectValue === 'all') { // 全てか個別化の判定
            this.prefElement = this.prefName;
        } else {
            this.prefElement = document.querySelectorAll('#list-' + this.prefSelectValue);
        }

    }

    prefUpdate() {

        //都道府県選択の削除
        if (this.prefsearchSelect.hasChildNodes()) {
            while (this.prefsearchSelect.childNodes.length > 0) {
                this.prefsearchSelect.removeChild(this.prefsearchSelect.firstChild);
            }
        }
        //都道府県選択の変更
        for (let i = 0; i < preflist.list.length; i++) {
            console.log(this.areaSelectValue);
            if (preflist.list[i].area === this.areaSelectValue || preflist.list[i].area === 'area00' || this.areaSelectValue === 'area00') {
                let _op = document.createElement("option");
                _op.value = preflist.list[i].val;
                _op.text = preflist.list[i].text;
                _op.setAttribute('data-val', preflist.list[i].area);
                this.prefsearchSelect.appendChild(_op);
            }
        }

    }

    prefReset() {
        for (let i = 0; i < this.prefName.length; i++) {
            TweenMax.set([this.prefName[i], this.prefName[i].nextElementSibling], {
                display: 'none',
                opacity: 0
            });
        }
    }

    prefSort() {
        if (this.prefElement.length > 0) {
            TweenMax.to(this.areaNothing, 0.3, {
                display: 'none',
                opacity: 0,
                ease: Power2.easeOut,
            });
            for (let i = 0; i < this.prefElement.length; i++) {
                TweenMax.set([this.prefElement[i], this.prefElement[i].nextElementSibling], {
                    display: 'block',
                    opacity: 1
                });
            }
        } else {
            TweenMax.set(this.area, {
                display: 'none',
                opacity: 0,
            });
            TweenMax.to(this.areaNothing, 0.3, {
                display: 'block',
                opacity: 1,
                ease: Power2.easeOut,
            });
        }
    }

    close(index) {

        this.selectIndex = index;

        this.areaName[this.selectIndex].classList.remove('is-open');
        this.areaName[this.selectIndex].classList.add('is-close');
        TweenMax.set(this.pref[this.selectIndex], {
            display: 'none',
            opacity: '0',
        });
        this.pref[this.selectIndex].classList.remove('is-open');

        setTimeout(() => {
            this.resize();
        }, 1e2);

    }

    open(index) {
        this.selectIndex = index;
        this.areaName[this.selectIndex].classList.add('is-open');
        this.areaName[this.selectIndex].classList.remove('is-close');
        TweenMax.to(this.pref[this.selectIndex], 0.3, {
            display: 'block',
            opacity: '1',
            ease: Power2.easeOut,
        });
        this.pref[this.selectIndex].classList.add('is-open');

        setTimeout(() => {
            this.resize();
        }, 1e2);


    }

    update() {

        let _selectArea = this.areasearchSelect.selectedIndex;
        _selectArea = this.areasearchSelect.options[_selectArea].text;
        this.areasearchSelect.previousElementSibling.innerText = _selectArea;

        let _selectPref = this.prefsearchSelect.selectedIndex;
        _selectPref = this.prefsearchSelect.options[_selectPref].text;
        this.prefsearchSelect.previousElementSibling.innerText = _selectPref;

    }

    //checkBox
    check(_checkedValue) {
        this.resetText();

        let _shopdata = []; // 各店舗の取扱商品の配列
        let _shopStatu = []; // チェックされている商品と取扱商品が一致するか

        // console.log("--------------------------------------------------");

        for (let i = 0; i < this.shopDetail.length; i++) {
            let _icon = this.shopDetail[i].lastElementChild;

            _shopdata[i] = [];

            //選択対象のクラスを定義
            let j = 0;
            let _checkCount = 0;
            const _$icon = _icon.querySelectorAll("li");
            while (j < _$icon.length) {
                let k = 0;
                while (k < _$icon[j].classList.length) {
                    if (_$icon[j].classList[k].match(/icon-/g)) {
                        const _name = _$icon[j].classList[k].replace("icon-", "");
                        // 各店舗の取扱商品の配列
                        _shopdata[i].push(_name);

                        // 取扱商品が_checkedValueに含まれているか(一致する = 0以上)
                        // 一致する商品の数だけ_checkCountが増える
                        if (_checkedValue.indexOf(_name) >= 0 && _checkCount < _checkedValue.length) {
                            _checkCount += 1;
                            // 取扱商品の数とチェックされている数（_checkedValue.length）が一致するか
                            // 一致するとtrue、そうでないときfalse
                            _shopStatu[i] = _checkCount === _checkedValue.length ? true : false

                            // 取扱商品の数より_checkedValue.lengthの方が多いときはfalse
                        } else if (_checkCount < _checkedValue.length) {
                            _shopStatu[i] = false
                        }

                        // console.log(_checkedValue.indexOf(_name), _name);

                    }
                    k += 1
                }
                j += 1
            }
            // console.log(_shopStatu[i]);

            // 店舗非表示
            let _delete = () => {
                TweenMax.set(this.shopDetail[i], {
                    display: 'none'
                });
                this.shopDetail[i].classList.remove('is-show');
            };
            // 店舗表示
            let _show = () => {
                TweenMax.set(this.shopDetail[i], {
                    display: 'flex'
                });
                this.shopDetail[i].classList.add('is-show');
            };

            if (_shopStatu[i] === false) {
                // 取扱店舗でないとき非表示
                _delete();
            } else {
                _show();
            }
        }

        this.insertText();

        setTimeout(() => {
            this.resize();
        }, 1e2);
    }

    insertText() {
        for (let j = 0; j < this.prefList.length; j++) {
            let _showSearch = this.prefList[j].querySelectorAll('.is-show');
            if (_showSearch.length === 0) {
                this.prefList[j].insertAdjacentHTML('afterbegin', '<div class="note-text">条件に合う店舗は現在ございません。<br class="sp">別の条件で検索をお願いいたします。<br>また、オンラインショップからも商品をご購入いただけます。</div>');
            }
        }
    }

    resetText() {
        let _text = document.querySelectorAll('.note-text');
        if (_text.length !== 0) {
            for (let j = 0; j < _text.length; j++) {
                _text[j].parentNode.removeChild(_text[j]);
            }
        }
    }

    resize() {
        document.body.style.height = this.$rootLoad.clientHeight + 'px';
    }
}